import type { Me, MeResponse } from "./interfaces";
import { signal } from "@preact/signals";
import requestApi from "~/core/api/request";

const makeApi = () => {
    const me = signal<Me | null>(null);
    const loading = signal(true);

    const fetchMe = async () => {
        const response = await requestApi<MeResponse>("/me");

        if (response.ok && response.data.email) {
            me.value = { email: response.data.email };
        } else {
            me.value = null;
        }

        loading.value = false;
    };

    const refetch = async () => {
        loading.value = true;

        await fetchMe();

        return me.peek();
    };

    fetchMe();

    return { me, loading, refetch };
};

export default makeApi;
